<template>
  <v-container fluid>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card class="maincard">
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12" xs="12" sm="6">
              <v-card-title>Kundenverwaltung</v-card-title>
            </v-col>
            <v-col cols="12" xs="12" sm="6" style="text-align: right;">
              <v-btn class="ml-3" color="secondary" @click="showImportDialog"
                >Importieren</v-btn
              >

              <v-btn class="ml-3" to="/customer/edit" color="success">
                <v-icon style="margin-right: 10px;">mdi-account-plus</v-icon>
                <span>Neuer Kunde</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <CustomerList />
      </v-card>
    </v-col>
    <v-dialog v-model="dlgImport" persistent max-width="90%">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Kunden importieren</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <csvImport
            @close="dlgImport = false"
            @cancel="dlgImport = false"
            @importCompleted="importComplete"
            :axiosInstance="getAxiosInstance()"
            importUrl="/customer/import"
            :importFields="importFields"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import CustomerList from "@/components/customers/CustomerList";
import DataService from "@/services/DataService";
import csvImport from "@/components/csv-import/csv-import";

export default {
  name: "CustomerMgmt",
  data: () => ({
    dlgImport: false,
    importFields: [
      { text: "Kdnr", value: "kdnr", width: "150px" },
      { text: "Name", value: "name", width: "300px" },
      { text: "Adresse", value: "adresse" },
      { text: "Plz", value: "plz" },
      { text: "Ort", value: "ort" },
      { text: "Land", value: "land" },
      { text: "Email", value: "email" },
      { text: "Telefon", value: "telefon" },
      { text: "Tag Bestellende", value: "bestellendeTag" },
      { text: "Zeit Bestellende", value: "bestellendeZeit" }
    ]
  }),
  components: { CustomerList, csvImport },
  methods: {
    getAxiosInstance() {
      return DataService.apiClient;
    },
    showImportDialog() {
      this.dlgImport = true;
    },
    importComplete() {
      this.loadCustomers();
    },
    loadCustomers() {
      this.loading = true;
      this.$store
        .dispatch("customer/fetchCustomerList")
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message
            });
          }
        });
    },
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped></style>
